import { useEffect, useRef } from 'react'
import { Outlet } from 'react-router-dom'
import { useTheme } from '../context/ThemeContext'
import { THEME_IDS } from '../styles/themes'

/**
 * ForceLightTheme - Forces light theme for specific routes
 *
 * Wraps routes that should always display in light theme (e.g., login, signup, onboarding).
 * Automatically restores the previous theme when navigating away.
 *
 * Usage in router:
 * {
 *   element: <ForceLightTheme />,
 *   children: [
 *     { path: '/login', element: <Login /> },
 *     { path: '/signup', element: <Signup /> },
 *   ]
 * }
 */
export const ForceLightTheme = () => {
    const { currentTheme, setTheme } = useTheme()
    const previousThemeRef = useRef(currentTheme)

    useEffect(() => {
        // Store the theme at mount time
        previousThemeRef.current = currentTheme

        // Only force light theme if we're not already on light theme
        if (currentTheme !== THEME_IDS.LIGHT) {
            setTheme(THEME_IDS.LIGHT)
        }

        // Cleanup: restore previous theme when component unmounts
        return () => {
            if (previousThemeRef.current !== THEME_IDS.LIGHT) {
                setTheme(previousThemeRef.current)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <Outlet />
}
